import Swiper, {Navigation, Lazy} from "swiper";
import {sliceIntoChunks} from "@main/helpers/slice-array-into-chunks";
import {MD_WIDTH, LG_WIDTH} from "@main/helpers/const.js";

const CHUNK_SIZE = 5;

class ProjectsSlider {
    constructor(el) {
        this.el = el;
        this.slides = this.el.querySelectorAll(".js-projects-item");
        this.slidesWrapper = this.el.querySelector(".swiper-wrapper");
        this.swiper;
        this.init();
        this.checkWidth();
    }

    checkWidth() {
        const breakpoint = window.matchMedia(`(min-width:${LG_WIDTH}px)`);

        this.breakpointChecker(breakpoint);
        breakpoint.addEventListener("change", () =>
            this.breakpointChecker(breakpoint)
        );
    }

    init() {
        this.swiper = new Swiper(this.el, {
            modules: [Navigation, Lazy],
            preloadImages: false,
            lazy: true,
            watchSlidesProgress: true,
            loadPrevNext: true,
            slidesPerView: "auto",
            spaceBetween: 8,
            breakpoints: {
                [MD_WIDTH]: {
                    spaceBetween: 16
                },
                [LG_WIDTH]: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                }
            },
            navigation: {
                nextEl: ".js-projects-next",
                prevEl: ".js-projects-prev"
            }
        });
    }

    breakpointChecker(breakpoint) {
        this.slidesWrapper.innerHTML = null;
        if (breakpoint.matches) {
            const chunkedSlides = sliceIntoChunks([...this.slides], CHUNK_SIZE);

            chunkedSlides.forEach(chunk => {
                const wrapper = document.createElement("div");
                const fragment = new DocumentFragment();

                wrapper.className = "swiper-slide projects__slides-wrapper";
                fragment.append(...chunk);
                wrapper.append(fragment);
                this.slidesWrapper.append(wrapper);


            });
        } else {
            const fragment = new DocumentFragment();
            fragment.append(...this.slides);
            this.slidesWrapper.append(fragment);
        }

        this.swiper.update();
        this.swiper.lazy.load();
    }
}

window.addEventListener("load", function() {
    document
        .querySelectorAll(".js-projects-slider")
        .forEach(slider => new ProjectsSlider(slider));
});
